import React from "react";
import styled from "@emotion/styled";
import { Box } from "@mui/material";

import { frame } from "../../../theme";
import { cardSx } from "./frameLayout";

/**
 * A band on the page: one card, full width of the content column.
 *
 * Its border was the literal string "1px solid tokens.textMuted33", which is
 * not a colour — the browser dropped the declaration, so every MainBox in the
 * product has been drawing no border at all. It now takes the frame's card:
 * hairline, card ground, 14px radius, 32px pad dropping to 24 below 1024.
 *
 * A caller can still override the padding; a caller overriding the radius is
 * drawing something that is not a card.
 */
const MainBox = styled(Box)(({ sx }) => ({
  ...cardSx(),
  width: "100%",
  ...(sx && sx.padding
    ? { padding: sx.padding, [`@media (max-width: ${frame.compactBreakpoint - 1}px)`]: { padding: sx.padding } }
    : {}),
}));

export default (props) => <MainBox sx={props.sx}>{props.children}</MainBox>;
